import React from "react";
import Form from "./Form";
import { useFormik } from "formik";
import { create } from "ducks/propertyTemplates";
import { add } from "ducks/toasts";

import { connect } from "react-redux";
import { useRemoveQueryNavigation } from "helpers/hooks/url";
const CreatePropertyTemplate = ({ add, create }) => {
  const onClose = useRemoveQueryNavigation("createPropertyTemplate");
  const { values, handleSubmit, setFieldValue } = useFormik({
    enableReinitialize: true,
    initialValues: { name: "", description: "", fields: [] },
    onSubmit: values => {
      create(values);
      add(
        "Update erfolgreich",
        "Benutzer wurde erfolgreich aktualisiert",
        "success",
        "user"
      );
    }
  });

  return values ? (
    <Form
      subtitle="Datenformat erstellen"
      values={values}
      handleChange={setFieldValue}
      handleSubmit={handleSubmit}
      handleClose={onClose}
    ></Form>
  ) : (
    false
  );
};

export default connect(null, { create, add })(CreatePropertyTemplate);
